import { Hooks } from '../../types/Hooks';
import smoothscroll from 'smoothscroll-polyfill';
import { CustomEventUtil } from '../../utils/CustomEventUtil';
import { CustomEvents } from '../../types/CustomEvents';

class Scroller {
  constructor(rootElement: HTMLAnchorElement) {
    smoothscroll.polyfill();
    this.rootElement = rootElement;
    this.navigation = document.querySelector(Hooks.NavigationRoot);

    this.init();
  }

  public rootElement: HTMLAnchorElement;
  public navigation: HTMLElement | null;

  private get hasTargetElement() {
    return this.rootElement.hash.charAt(0) === '#' && this.rootElement.hash.length > 1;
  }

  private get isExempt() {
    return this.rootElement.classList.contains('js-no-scroll');
  }

  private get target() {
    return document.querySelector<HTMLElement>(this.rootElement.hash);
  }

  private get scrollOffset() {
    const navigationHeight = this.navigation?.offsetHeight ?? 0;
    return this.withOffset ? navigationHeight : 0;
  }

  private get withOffset() {
    return this.target?.dataset.withOffset !== 'false' ?? true;
  }

  private get onClickEvent() {
    return this.rootElement.dataset.onClickEvent as keyof typeof CustomEvents ?? '';
  }

  private handleClick = (e: MouseEvent) => {
    if (this.target) {
      e.preventDefault();

      const targetPosition = this.target.offsetTop;

      window.scrollTo({
        top: targetPosition - this.scrollOffset,
        behavior: 'smooth',
      });

      if (this.onClickEvent) {
        CustomEventUtil.send(CustomEvents[this.onClickEvent]);
      }
    }
  }

  public init() {
    if (this.hasTargetElement && !this.isExempt) {
      this.rootElement.addEventListener('click', this.handleClick);
    }
  }
}

export { Scroller };
